import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { ProductImage } from './ProductImage';
type HeroSectionProps = {
  guaranteeEnabled: boolean;
};
export function HeroSection({
  guaranteeEnabled
}: HeroSectionProps) {
  return <header className="bg-navy px-4 pb-6 pt-5 text-center md:px-10 md:pb-7 md:pt-6" data-id="element-97" data-mp="28u4ncn43lelf">
      <p className="font-heading text-[13px] font-extrabold uppercase tracking-[0.08em] text-aqua md:text-[15px]" data-id="element-98" data-mp="28vzbsbekvou9">
        Complete Orthopedic &amp; Trauma Toolkit™
      </p>
      <h1 className="mt-1.5 font-heading text-[24px] font-extrabold uppercase leading-[1.08] tracking-[-0.3px] text-white md:text-[34px]" data-id="element-99" data-mp="30kiywcon2etx">
        The complete clinical resource system for{' '}
        <span className="text-aqua" data-id="element-100" data-mp="2rrfpcfh46m4k">orthopedic surgeons &amp; trauma specialists</span>
      </h1>
      <p className="mx-auto mt-3 max-w-[580px] text-[14px] leading-[1.45] text-white md:text-[16px]" data-id="element-101" data-mp="3fh0b164njxhj">
        Assessments, differential diagnoses, fractures, trauma, treatment decisions, and documentation — organized in one
        collection for experienced specialists, not basic explanations.
      </p>
      <p className="mx-auto mt-2.5 max-w-[560px] font-heading text-[13px] font-extrabold uppercase leading-tight text-gold md:text-[15px]" data-id="element-102" data-mp="2bfrq84azbhsd">
        Less time searching. More organized clinical resources.
      </p>

      <div className="mx-auto mt-3 max-w-[340px]" data-id="element-103" data-mp="2kcikqc9vuoku">
        <ProductImage data-id="element-104" data-mp="2z2gauxrdhoco" />
      </div>

      <h2 className="mx-auto mt-2 max-w-[520px] font-heading text-[16px] font-extrabold uppercase leading-snug text-white md:text-[19px]" data-id="element-105" data-mp="2z1ohltl902pk">
        Complete Orthopedic &amp; Trauma Toolkit™
      </h2>
      <p className="mt-1 font-heading text-[13px] font-extrabold uppercase leading-tight text-aqua md:text-[15px]" data-id="element-106" data-mp="383eevg1t9vv9">
        6 Advanced Clinical Volumes + 5 FREE Professional Bonuses
      </p>

      <div className="mt-3.5" data-id="element-107" data-mp="1dqewxg9ykpkt">
        <CtaButton mode="scroll" data-id="element-108" data-mp="18r3du0m4d802">Yes! I want the complete toolkit</CtaButton>
      </div>
      <p className="mt-3 font-heading text-[11px] font-bold uppercase tracking-[0.12em] text-white md:text-[12px]" data-id="element-109" data-mp="18tg4d25y0qoq">
        Get your orthopedic resources organized today.
      </p>
      <p className="mx-auto mt-1 max-w-[440px] font-heading text-[11px] font-bold uppercase leading-snug text-white md:text-[12px]" data-id="element-110" data-mp="3dso651p2ko2p">
        {guaranteeEnabled && <>
            <ShieldCheckIcon className="mr-1 inline h-3.5 w-3.5 -translate-y-px text-aqua" aria-hidden data-id="element-111" data-mp="3munopyfqg07r" />
            7-day money-back guarantee •{' '}
          </>}
        6 volumes + 5 FREE bonuses
      </p>
    </header>;
}